import { Component, input } from '@angular/core';

@Component({
  selector:    'v-error-content',
  templateUrl: './v-error-content.component.haml',
  styleUrls:   ['./v-error-content.component.sass'],
  standalone:  false
})
export class VErrorContentComponent {
  value = input<{errorText: string, command: Function}>(undefined);
}
